/**
 * Placa de veículo, padrão antigo (`ABC-1234`) e Mercosul (`ABC1D23`). Uppercase e
 * alfanumérica. Como os documentos, exibe formatado e emite normalizado (maiúsculas,
 * sem hífen). A distinção dos dois padrões está em `lib/mascaras.ts`.
 */
import { useId } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { desformatar, formatar } from '@/lib/mascaras';

export function CampoPlaca({
  rotulo,
  valor,
  onChange,
  id,
  obrigatorio,
}: {
  rotulo: string;
  valor: string;
  onChange: (normalizado: string) => void;
  id?: string;
  obrigatorio?: boolean;
}) {
  const gerado = useId();
  const campoId = id ?? gerado;

  return (
    <div className="flex flex-col gap-2">
      <Label htmlFor={campoId}>{rotulo}</Label>
      <Input
        id={campoId}
        required={obrigatorio}
        placeholder="ABC1D23"
        autoCapitalize="characters"
        className="font-mono uppercase"
        value={formatar(valor, 'placa')}
        onChange={(e) => onChange(desformatar(e.target.value, 'placa'))}
      />
    </div>
  );
}
